export default "__VITE_ASSET__6357d77f__"